<template>
    <font-awesome-icon icon="sync-alt" size="lg" class="icon-button ml-auto p-text-primary" title="Atualizar" />
</template>
